import React from "react";
import { getAssets } from "@unisearch/helpers";
import { LayoutMain } from "@unisearch/theme/layout";
import UniPageSectionWithDropdown from "@modules/study/unipages/section_with_dropdown";
import {
  UniPageLandingHero,
  UniPageLandingConnect,
  UniPageBookingDemo,
} from "@modules/study/unipages/landing";
import styles from "./index.module.scss";

const discoverData = [
  {
    id: 1,
    title: "Profile-match",
    description:
      "Find out which students out of an active pool of over 100,000 users are matching with your programs through our AI-powered profile evaluation.",
  },
  {
    id: 2,
    title: "Track Engagement",
    description:
      "Learn which prospects are most engaged on your pages through real-time, detailed alerts of individual student activity.",
  },
  {
    id: 3,
    title: "Direct Profile Access",
    description:
      "Take a closer look at your best-fit, most-engaged students by directly accessing their individual profiles.",
  },
  {
    id: 4,
    title: "Real-Time Engagement Insights",
    description:
      "Apply informed engagement and enrollment strategies with data-driven insight into how your audiences are responding to your student touchpoints overall, over time, and by location.",
  },
];
const engageData = [
  {
    id: 1,
    title: "One-to-One Communication",
    description:
      "Connect with students in real-time through email and one-to-one chat options.",
  },
  {
    id: 2,
    title: "Personalised Program Recommendations",
    description:
      "Tailor program suggestions to individual students after viewing their student profile.",
  },
  {
    id: 3,
    title: "Collaborate with Local Experts",
    description:
      "Work together with dedicated regional teams to enhance recruitment outcomes in distinct markets.",
  },
  {
    id: 4,
    title: "Create Global Partnership Opportunities",
    description:
      "Explore opportunities to partner and collaborate with target market institutions, liaised through UniSearch.",
  },
  {
    id: 5,
    title: "Appoint International Student Mentors",
    description:
      "International students in your community connect with and represent your university to prospects through a student’s perspective.",
  },
  {
    id: 6,
    title: "Manage Student Touchpoints",
    description:
      "From uploading course and profile content to curating rich media galleries and blogs, manage every student point of contact through an intuitive dashboard.",
  },
  {
    id: 7,
    title: "Host and Participate in Virtual Events",
    description:
      "Access unique opportunities to engage students in diverse markets by participating in on-ground and virtual fairs hosted by UniSearch, or through your own virtual events.",
  },
];

const covertData = [
  {
    id: 1,
    title: "Responsive Conversion Solutions",
    description:
      "Know at a glance how many students are converting, how many applications are underway, and when to follow up to boost application completion.",
  },
  {
    id: 2,
    title: "Decision-Making Driven by Data and Human Expertise",
    description:
      "Effectively allocate resources, minimise risk, and create informed recruitment strategies with market-specific analytics and insight into target audience consumption and behaviour.",
  },
  {
    id: 3,
    title: "Higher Completion Rates",
    description:
      "Boost conversion and program completion rates through a simplified and streamlined enrolment pipeline, 360-degree engagement with students, and comprehensive post-application support.",
  },
];

const University = () => {
  return (
    <LayoutMain
      title="International Student Recruitment Strategy | UniSearch for University"
      fixedPopup={false}
      metaUrl={`${process.env.NEXT_PUBLIC_URL}/university`}
    >
      <UniPageLandingHero />
      <UniPageSectionWithDropdown
        customClasses={{ root: styles.section_discover }}
        data={discoverData}
        imageLeft
        image={getAssets("assets/images/unipage/discover.png")}
        title="Discover"
        description="Optimise the time and resources used to locate your key audiences through a continuous, to-the-minute flow of your best-fit, most-engaged prospects, right at your fingertips."
      />
      <UniPageSectionWithDropdown
        customClasses={{ root: styles.section_engage }}
        data={engageData}
        image={getAssets("assets/images/unipage/engage.png")}
        title="Engage"
        description="Creating the right connections is at the heart of successful student recruitment. Explore diverse channels to create meaningful interpersonal connections with your prospects and other key stakeholders."
      />
      <UniPageSectionWithDropdown
        customClasses={{ root: styles.section_discover }}
        data={covertData}
        imageLeft
        image={getAssets("assets/images/unipage/convert2.png")}
        title="Convert"
        description="Boost prospect conversion and application completion rates through end-to-end interpersonal communication, collaborative efforts with regional experts, and an intuitive, streamlined enrolment pipeline."
      />
      <UniPageLandingConnect />
      <UniPageBookingDemo />
    </LayoutMain>
  );
};

export default University;
